import { render } from "./ProgressCircle.vue?vue&type=template&id=12b2b9f7&scoped=true"
import script from "./ProgressCircle.vue?vue&type=script&lang=js"
export * from "./ProgressCircle.vue?vue&type=script&lang=js"

import "./ProgressCircle.vue?vue&type=style&index=0&id=12b2b9f7&lang=css"
import "./ProgressCircle.vue?vue&type=style&index=1&id=12b2b9f7&scoped=true&lang=css"

import exportComponent from "C:\\Server-Testumgebung\\way-academy-app-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b2b9f7"]])

export default __exports__